var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0887 24.3494C32.2926 22.5839 33.0001 20.427 33.0001 18.0985C33.0001 12.1205 28.3369 7.27441 22.5845 7.27441C16.8322 7.27441 12.1689 12.1205 12.1689 18.0985C12.1689 20.4271 12.8765 22.5839 14.0804 24.3495L22.5845 38.7255L31.0887 24.3494Z",
    fill: "#3CB500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationButton);
export default __webpack_public_path__ + "static/media/location-button.e6872cd5e1aa7236e835c70ab27ecdb9.svg";
export { ForwardRef as ReactComponent };